import { render, staticRenderFns } from "./TransactionPixReceiptSuccess.vue?vue&type=template&id=5f267d7c&"
import script from "./TransactionPixReceiptSuccess.vue?vue&type=script&lang=js&"
export * from "./TransactionPixReceiptSuccess.vue?vue&type=script&lang=js&"
import style0 from "./TransactionPixReceiptSuccess.vue?vue&type=style&index=0&id=5f267d7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports